import { useQuery } from '@tanstack/react-query';
import type { MaterialDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueMaterialsApiResponse {
  success: boolean;
  data: MaterialDto[];
}

/**
 * Hook to fetch all available materials from the catalogue.
 * Calls GET /catalogue/materials.
 */
export function useMaterials() {
  return useQuery({
    queryKey: queryKeys.catalogue.materials(),
    queryFn: async () => {
      const response = await apiClient.get<CatalogueMaterialsApiResponse>('/catalogue/materials');
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
